import { convertProxyImgUrl } from 'client/utils/getProxyImgUrl';

const originalFileFirstPathName = 'picture-origin';
const compressedFileFirstPathName = 'picture-compressed';
const compressedSizes = [
    { size: 800, type: 'md', imgSize: 768 },
    { size: 1200, type: 'lg', imgSize: 1280 }
];

export default function generatePictureSourceData(src) {
    const re = /(https:\/\/.+?)\/(.+?)\/(.+)\/(.+)\.(\w+)/i;
    const parsed = re.exec(src);
    if (parsed) {
        const [, origin, firstPath, restPath, filename, ext] = parsed;
        if (firstPath === originalFileFirstPathName) {
            const sources = compressedSizes.map(({ size, type }) => ({
                srcSet: `${origin}/${compressedFileFirstPathName}/${restPath}/${filename}-${type}.${ext}`,
                media: `(max-width: ${size}px)`
            }));
            return sources;
        }
    }
    return [];
}

export function generatePictureSourceDataByProxyImage(src) {
    if (!src) return [];
    const re = /(https:\/\/.+?)\/(.+?)\/(.+)\/(.+)\.(\w+)/i;
    const parsed = re.exec(src);
    const ext = parsed[parsed.length - 1];
    const sources = compressedSizes.map(({ size, imgSize }) => ({
        // svg 不支援縮圖功能，所以用全圖
        srcSet:
            ext === 'svg'
                ? src
                : convertProxyImgUrl({
                      url: src,
                      resizeWidth: imgSize
                  }),
        media: `(max-width: ${size}px)`
    }));
    return sources;
}
